import ev from '../../lib/eb.js'
export default function unmount(){
  ev.removeEventListener('switchtoggled', this.notationViewListener)
}
